module.exports = __webpack_public_path__ + "static/media/aboutUs-Developers.03ff5ce7.png";